import { Color } from '@diritto/common/style/color';
import { FontWeight, Typography } from '@diritto/common/style/typography';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { ReplyOrder, ReplyOrderText } from '@diritto/common/reply/constants';

export const ReplyOrderTypeMenu = ({
  orderType,
  onChangeOrderType,
}: {
  orderType: ReplyOrder;
  onChangeOrderType?: (value: ReplyOrder) => void;
}) => {
  const orderList = [ReplyOrder.Latest, ReplyOrder.Like];
  return (
    <StyledOrderTypeWrapper>
      {orderList.map(it => (
        <StyledOrderType key={it} isActive={it === orderType} onClick={() => onChangeOrderType?.(it)}>
          {ReplyOrderText[it]}
        </StyledOrderType>
      ))}
    </StyledOrderTypeWrapper>
  );
};

const StyledOrderTypeWrapper = styled.div`
  display: flex;
  position: absolute;
  right: 0;
`;

const StyledOrderType = styled.div(
  ({ isActive = false }: { isActive?: boolean }) => css`
    height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    cursor: pointer;
    text-align: center;
    padding: 14px 0;
    margin-left: 10px;

    color: ${Color.Black};
    font-weight: ${isActive ? FontWeight.Bold : FontWeight.Regular};
    ${Typography.XXSmall};
  `,
);
